import React from 'react'
import styled from 'styled-components';

const ProfileContainer = styled.div`
  flex: 6;
  margin-top: 70px;
`;


const Department = () => {
  return (
    <ProfileContainer>
    <div>Department</div>
      </ProfileContainer>
  )
}

export default Department